<template>
  <b-modal
    id="popup_notification_modal"
    size="md"
    title-tag="h4"
    title-class="text-left popup-notification-modal__title"
    header-border-variant="white"
    :title="modalTitle"
    footer-border-variant="white"
    @hide="!alreadySeen ? maskAsSeen() : null"
    centered
    no-close-on-esc
    no-close-on-backdrop
  >
    <div
      v-if="shownNotification"
      class="px-4 py-3 popup-notification-modal__content"
    >
      <p class="mb-0 text-left popup-notification-modal__body">
        {{ shownNotification.body }}
      </p>
    </div>

    <template #modal-footer>
      <b-button
        v-if="shownNotification"
        variant="popup-button"
        class="ml-auto"
        :aria-label="
          $t('PopupNotificationComponent.action_aria', {
            action: shownNotification.action,
          })
        "
        @click="doNotificationAction(shownNotification)"
      >
        {{ shownNotification.action }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { popupService } from "@/_services";
export default {
  name: "PopupNotificationComponent",
  computed: {
    ...mapState({
      alert: (state) => state.alert,
    }),
    modalTitle: function () {
      if (this.shownNotification) {
        return this.shownNotification.title;
      }
      return "";
    },
    alreadySeen: function () {
      return this.shownNotification ? this.shownNotification.seen : true;
    },
  },
  watch: {
    notifications: function (value) {
      if (!this.shownNotification && value.length > 0) {
        this.shownNotification = value[0];
        this.$bvModal.show("popup_notification_modal");
      }
    },
  },
  data() {
    return {
      notifications: [],
      pollingTimeout: null,
      shownNotification: null,
      actionTextToRoutesMap: {
        "Vai al Teleconsulto Rapido": {
          name: "teleconsulto",
          params: { section: "rapido" },
        },
        "Vai al Teleconsulto Specialistico": {
          name: "teleconsulto",
          params: { section: "specialistico" },
        },
        "Vai al Teleconsulto Pedriatico": {
          name: "teleconsulto",
          params: { section: "pediatrico" },
        },
      },
    };
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
      openAndBlock: "modal/openAndBlock",
      clearModal: "modal/clear",
    }),
    fetchData() {
      const self = this;
      popupService
        .getUserPopupNotifications({ unseen: true })
        .then(function (res) {
          self.notifications = res.data.data;
        })
        .catch(function () {
          self.errorAlert(self.$t("PopupNotificationComponent.fetch_error"));
        });
    },
    maskAsSeen() {
      const self = this;
      return popupService
        .markPopupNotificationAsSeen(this.shownNotification?.hashid)
        .then(function (res) {
          self.shownNotification = null;
          return res;
        })
        .catch(function (err) {
          self.errorAlert(self.$t("PopupNotificationComponent.seen_error"));
          throw err;
        });
    },
    setPollingTimeout() {
      const self = this;
      this.pollingTimeout = setInterval(function () {
        if (!self.shownNotification) {
          self.fetchData();
        }
      }, 4500);
    },
    doNotificationAction(notification) {
      const actionLower = notification.action?.toLowerCase();
      const matchingRoute = Object.entries(this.actionTextToRoutesMap).find(
        function ([key]) {
          return key.toLowerCase() === actionLower;
        }
      );
      let newRoute = notification.action_route || null;

      if (typeof newRoute === "string") {
        newRoute = { path: newRoute };
      }

      newRoute = newRoute || (matchingRoute ? matchingRoute[1] : null);

      if (newRoute) {
        const self = this;

        this.maskAsSeen().then(function () {
          self.$bvModal.hide("popup_notification_modal");

          const targetRoute = self.$router.resolve(newRoute).route;

          if (targetRoute.fullPath !== self.$route.fullPath) {
            self.$router.push(newRoute).catch(function () {});
          }
        });
      } else {
        console.warn("Nessuna route trovata per l'azione popup");
      }
    },
  },
  created() {
    this.setPollingTimeout();
  },
  beforeDestroy() {
    clearInterval(this.pollingTimeout);
  },
};
</script>

<style scoped>
.popup-notification-modal__content {
  max-height: 70vh;
  overflow-y: auto;
}

.popup-notification-modal__body {
  font-size: 1rem;
  line-height: 1.5;
}

.popup-notification-modal__title {
  color: inherit;
}
</style>
